import styled from 'styled-components';

const TaskActions = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`

export default TaskActions